import { Box, IconButton, Text } from '@chakra-ui/react';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';
import { FaPencil } from 'react-icons/fa6';

type LineItem = {
  label: string;
  amount: number;
  editAction?: () => void;
};

type Props = {
  label: string;
  amount: number;
  items?: LineItem[];
  variant?: 'default' | 'total';
};

const LineItemGroup = ({ label, amount, items, variant = 'default' }: Props): JSX.Element => {
  const formatCurrency = useCurrencyFormatter();
  const isTotal = variant === 'total';

  return (
    <Box display={'flex'} flexDirection={'column'} gap={1.5}>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={1}>
          <Text fontWeight={isTotal ? 600 : 400}>{label}</Text>
        </Box>
        <Text fontWeight={isTotal ? 600 : 400} fontSize={isTotal ? '1.125rem' : undefined}>
          {formatCurrency(amount)}
        </Text>
      </Box>
      {items?.map((item, index) => (
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} key={index} pl={4}>
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={1}>
            <Text fontSize={'0.875rem'} color={'gray.500'}>
              {item.label}
            </Text>
            {item.editAction && (
              <IconButton
                aria-label={`Editar ${item.label}`}
                icon={<FaPencil />}
                type="button"
                variant="unstyled"
                size="xs"
                color={'gray.500'}
                display={'flex'}
                alignItems={'center'}
                minW="auto"
                _hover={{ color: 'gray.700' }}
                onClick={item.editAction}
              />
            )}
          </Box>
          <Text fontSize={'0.875rem'} color={'gray.500'}>
            {formatCurrency(item.amount)}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default LineItemGroup;
